// smModal: cross-browser dialog helper (also defined in variant-main-picker.liquid)
if (!window.smModal) {
  (function () {
    if (typeof HTMLDialogElement === 'undefined' || typeof HTMLDialogElement.prototype.showModal !== 'function') {
      document.documentElement.classList.add('no-dialog');
    }
    window.smModal = {
      open: function (id) {
        var d = document.getElementById(id);
        if (!d) return;
        if (!document.documentElement.classList.contains('no-dialog')) {
          try { d.showModal(); return; } catch (e) {}
        }
        d.setAttribute('open', '');
        var bd = document.createElement('div');
        bd.className = 'sm-modal-backdrop';
        bd.setAttribute('data-for', id);
        bd.addEventListener('click', function () { window.smModal.close(d); });
        document.body.appendChild(bd);
      },
      close: function (el) {
        var d = (el && el.tagName === 'DIALOG') ? el : (el && el.closest ? el.closest('dialog') : null);
        if (!d) return;
        try { if (typeof d.close === 'function') d.close(); } catch (e) {}
        d.removeAttribute('open');
        var bd = document.querySelector('.sm-modal-backdrop[data-for="' + d.id + '"]');
        if (bd && bd.parentNode) bd.parentNode.removeChild(bd);
      }
    };
  })();
}

if (!customElements.get('cart-upsell-carousel')) {
  class CartUpsellCarousel extends HTMLElement {
    connectedCallback() {
      this.current = 0;
      this.count = parseInt(this.dataset.count || 1);
      const wrapper = this.closest('.cart-upsell');
      wrapper?.querySelector('.cart-upsell__prev')?.addEventListener('click', () => this.go(-1));
      wrapper?.querySelector('.cart-upsell__next')?.addEventListener('click', () => this.go(1));
    }
    go(dir) {
      this.current = (this.current + dir + this.count) % this.count;
      this.querySelector('.cart-upsell__track').style.transform = `translateX(-${this.current * 100}%)`;
    }
  }
  customElements.define('cart-upsell-carousel', CartUpsellCarousel);
}

if (!customElements.get('cart-upsell-add')) {
  class CartUpsellAdd extends HTMLElement {
    connectedCallback() {
      setTimeout(() => {
        const btn = this.querySelector('button');
        if (!btn) return;
        btn.addEventListener('click', () => {
          if (this.dataset.multiVariant) {
            this._showVariantModal();
          } else {
            this._performAdd(this.dataset.variantId, null, null);
          }
        });
      }, 0);
    }

    _showVariantModal() {
      const productData = JSON.parse(this.querySelector('.cart-upsell__product-data').textContent);
      const modal = document.getElementById('cart-upsell-modal');
      const body = document.getElementById('cart-upsell-modal-body');

      this._productData = productData;
      this._selectedOptions = productData.options.map(opt => {
        const avail = opt.values.find(v => v.available);
        return (avail || opt.values[0]).name;
      });

      body.innerHTML = this._buildModalHTML(productData);

      productData.options.forEach((opt, idx) => {
        const val = this._selectedOptions[idx];
        const radio = body.querySelector(`input[name="cupm-opt-${idx}"][value="${val.replace(/"/g, '\\"')}"]`);
        if (radio) radio.checked = true;
      });

      this._updateAddBtn(body);

      body.querySelectorAll('.cupm-option__input').forEach(input => {
        input.addEventListener('change', () => {
          this._selectedOptions[parseInt(input.dataset.optionIndex)] = input.value;
          this._updateAddBtn(body);
          this._updateModalImage(body);
        });
      });

      body.querySelector('.cupm-add-btn').addEventListener('click', () => {
        const variant = this._findVariant();
        if (variant && variant.available) {
          this._performAdd(variant.id.toString(), modal, body.querySelector('.cupm-add-btn'));
        }
      });

      window.smModal.open('cart-upsell-modal');
    }

    _buildModalHTML(product) {
      const sizeOptions = ['size', 'shoe size', 'sock size'];
      const titleLower = product.title.toLowerCase();
      const isSockProduct = titleLower.includes('sock') || titleLower.includes('compression');
      const isSandalProduct = titleLower.includes('solerest') || titleLower.includes('sandal') || titleLower.includes('flip flop') || titleLower.includes('recovery slide');

      let html = `<div class="cupm-product">
        ${product.image ? `<img src="${product.image}" class="cupm-product__image" alt="">` : ''}
        <div class="cupm-product__info">
          <p class="cupm-product__title">${product.title}</p>
          <p class="cupm-product__price">
            ${product.hasComparePrice ? `<s class="cupm-product__compare">${product.compareAtPriceFormatted}</s> ` : ''}
            <span>${product.priceFormatted}</span>
          </p>
        </div>
      </div>
      <div class="cupm-options">`;

      product.options.forEach((opt, optIdx) => {
        const isSize = sizeOptions.some(s => opt.name.toLowerCase().includes(s));
        const sizeModalId = (isSockProduct || opt.name.toLowerCase().includes('sock'))
          ? 'cupm-size-chart-socks'
          : isSandalProduct
            ? 'cupm-size-chart-sandal'
            : 'cupm-size-chart-shoes';

        html += `<div class="cupm-option">
          <div class="cupm-option__legend">
            <span class="cupm-option__name">${opt.name}</span>
            ${isSize ? `<button type="button" class="size-chart-trigger" onclick="smModal.open('${sizeModalId}')">
              <span class="material-symbols-rounded" aria-hidden="true">straighten</span>
              <span class="size-chart-trigger__label">Size chart</span>
            </button>` : ''}
          </div>
          <div class="cupm-option__buttons">`;

        opt.values.forEach(value => {
          html += `<label class="cupm-option__label${!value.available ? ' cupm-option__label--unavailable' : ''}">
            <input type="radio" name="cupm-opt-${optIdx}" value="${value.name.replace(/"/g, '&quot;')}"
              data-option-index="${optIdx}"
              class="cupm-option__input"
              ${!value.available ? 'disabled' : ''}>
            <span class="cupm-option__btn-text">${value.name}</span>
          </label>`;
        });

        html += `</div></div>`;
      });

      html += `</div>
        <button type="button" class="cupm-add-btn button"><span>Add to Cart</span></button>`;

      return html;
    }

    _findVariant() {
      return this._productData.variants.find(v =>
        this._productData.options.every((opt, i) => v.options[i] === this._selectedOptions[i])
      );
    }

    _updateModalImage(body) {
      const variant = this._findVariant();
      if (!variant || !variant.image) return;
      const img = body.querySelector('.cupm-product__image');
      if (img) img.src = variant.image;
    }

    _updateAddBtn(body) {
      const btn = body.querySelector('.cupm-add-btn');
      if (!btn) return;
      const variant = this._findVariant();
      const available = variant && variant.available;
      btn.disabled = !available;
      btn.querySelector('span').textContent = available ? 'Add to Cart' : 'Sold out';
    }

    async _performAdd(variantId, modal, btn) {
      const triggerBtn = btn || this.querySelector('button');
      triggerBtn.disabled = true;
      const span = triggerBtn.querySelector('span') || triggerBtn.querySelector('.button-text');
      if (span) span.textContent = '...';

      try {
        const data = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1, sections: this.dataset.sectionId })
        }).then(r => r.json());

        const sectionHtml = data.sections?.[this.dataset.sectionId];
        if (sectionHtml) {
          const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
          const newEl = doc.querySelector('cart-items-component');
          const currentEl = document.querySelector('cart-items-component');
          if (newEl && currentEl) currentEl.innerHTML = newEl.innerHTML;
        }

        if (modal) modal.close();
      } catch {
        triggerBtn.disabled = false;
        if (span) span.textContent = btn ? 'Add to Cart' : 'ADD';
      }
    }
  }
  customElements.define('cart-upsell-add', CartUpsellAdd);
}
